import React from 'react';
import { iconSize } from './constants.mjs';

const withoutBoundingBoxWidth = {
  large: 34,
  medium: 25,
  small: 18,
  xSmall: 15
};
const CartOneDigitIcon = ({ size = "medium", withBoundingBox = true, ...others }) => {
  let iconWidth, iconHeight;
  if (typeof size === "string") {
    iconWidth = withBoundingBox ? iconSize[size] : withoutBoundingBoxWidth[size];
    iconHeight = iconSize[size];
  } else {
    iconWidth = size;
    iconHeight = size;
  }
  return /* @__PURE__ */ React.createElement(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: iconWidth,
      height: iconHeight,
      viewBox: "0 0 30 30",
      preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
      fill: "none",
      ...others
    },
    /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "M2.34009 5.84998H6.88616L10.129 19.6299H22.5529L25.6398 7.73624H26.666L23.3477 20.63H9.33401L6.09409 6.84998H2.34009V5.84998Z",
        fill: "currentColor"
      }
    ),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "M11.3801 23.03C11.3801 23.643 10.8831 24.14 10.2701 24.14C9.65706 24.14 9.1601 23.643 9.1601 23.03C9.1601 22.4169 9.65706 21.92 10.2701 21.92C10.8831 21.92 11.3801 22.4169 11.3801 23.03Z",
        fill: "currentColor"
      }
    ),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "M22.7901 24.14C23.4031 24.14 23.9001 23.643 23.9001 23.03C23.9001 22.4169 23.4031 21.92 22.7901 21.92C22.177 21.92 21.6801 22.4169 21.6801 23.03C21.6801 23.643 22.177 24.14 22.7901 24.14Z",
        fill: "currentColor"
      }
    )
  );
};
CartOneDigitIcon.iconName = "CartOneDigitIcon";

export { CartOneDigitIcon };
